import React, { useEffect } from 'react';
import { initFacebookPixel, trackEvent } from '../lib/fbPixel';
/**
 * Mounts the Meta (Facebook) Pixel once and fires PageView + ViewContent
 * for the landing page. Place once at the root of the app.
 * Fails silently if the pixel script is blocked.
 */
export function FacebookPixel() {
  useEffect(() => {
    try {
      initFacebookPixel();
      trackEvent('ViewContent', {
        content_name: 'VOLEY 360 Landing',
        content_category: 'Landing Page'
      });
    } catch {
      // Never let analytics setup break the page
    }
  }, []);
  return null;
}